import React, {useMemo} from 'react';
import {Table} from 'semantic-ui-react';
import {useTable, usePagination} from 'react-table';
import {Filter, DefaultColumnFilter} from './tableFilters';
import './styles.scss';
const columnsTable = [
  {
    'Header': 'Línea',
    'accessor': 'line',
  },
  {
    'Header': 'Pedido',
    'accessor': 'order',
  },
  {
    'Header': 'Orden No.',
    'accessor': 'item',
  },
  {
    'Header': 'Descripción',
    'accessor': 'modelDescription',
    'width': 1,
  },
  {
    'Header': 'Chasis',
    'accessor': 'chassis',
  },
  {
    'Header': 'Katashiki',
    'accessor': 'masterCode',
    'width': 2000,
  },
  {
    'Header': 'Sfx',
    'accessor': 'suffix',
  },
  {
    'Header': 'Color Externo',
    'accessor': 'externalColorDescription',
  },
  {
    'Header': 'Código Externo',
    'accessor': 'color',
  },
  {
    'Header': 'Color Interno',
    'accessor': 'internalColorDescription',
  },
  {
    'Header': 'Código Interno',
    'accessor': 'internalColor',
  },
  {
    'Header': 'Motor',
    'accessor': 'motor',
  },
  {
    'Header': 'Año Modelo',
    'accessor': 'yearModel',
  },
  {
    'Header': 'ETD',
    'accessor': 'dateOfShipmentText',
  },
  {
    'Header': 'ETA',
    'accessor': 'dateOfArrivalText',
  },
  {
    'Header': 'Embarque',
    'accessor': 'ship',
  },
  {
    'Header': 'Factura Origen',
    'accessor': 'invoiceNumber',
  },
  {
    'Header': 'Asignado',
    'accessor': 'reservation',
  },
  {
    'Header': 'Importador',
    'accessor': 'importer',
  },
  {
    'Header': 'Destino',
    'accessor': 'destiny',
  },
  {
    'Header': 'C&F',
    'accessor': 'cif',
  },
  {
    'Header': 'Estado Registro',
    'accessor': 'registerState',
  },
  {
    'Header': 'Fecha Priorización',
    'accessor': 'prioritizationDate',
  },
  {
    'Header': 'Tipo Venta',
    'accessor': 'vehicleTypeDescription',
  },
  {
    'Header': 'Agencia Destino',
    'accessor': 'agencyName',
  },
  {
    'Header': 'Cliente Final',
    'accessor': 'finalCustomerName',
  },
];
const VehiclesInfTable = ({setReportList}) => {
  const data = useMemo(() => setReportList, []);
  const columns = useMemo(() => columnsTable, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    usePagination
  );
  return (
    <>
      <div className='commercial-table-wrapper'>
        <Table className='interactive' compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center' {...cell.getCellProps()} singleLine>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};
export default VehiclesInfTable;
